import { Notyf } from 'notyf';

window.notify = new Notyf({
    duration: window.NOTYF_DURATION ?? 3000,
    ripple: false,
    position: {
        x: 'right',
        y: 'bottom',
    },
    types: [
        {
            type: 'success',
            className: 'alert-message',
            background: 'var(--rc-alert-green)',
            dismissible: true,
            icon: {
                className: 'fad fa-check-circle alert-icon',
                tagName: 'i',
                color: 'white'
            }
        },
        {
            type: 'warning',
            className: 'alert-message',
            background: 'var(--rc-alert-yellow)',
            dismissible: true,
            icon: {
                className: 'far fa-exclamation-triangle text-white text-4xl',
                tagName: 'i',
                color: 'white'
            }
        },
        {
            type: 'error',
            className: 'alert-message',
            background: 'var(--rc-alert-red)',
            dismissible: true,
            icon: {
                className: 'far fa-exclamation-circle text-white text-4xl',
                tagName: 'i',
                color: 'white'
            }
        },
        {
            type: 'info',
            className: 'alert-message',
            background: 'var(--rc-alert-blue)',
            dismissible: true,
            icon: {
                className: 'far fa-info-circle text-white text-4xl',
                tagName: 'i',
                color: 'white'
            }
        }
    ]
});

Livewire.on('show-notification', event => {
    switch (event.type) {
        case 'error':
            notify.error(event.message);
            break;
        case 'success':
            notify.success(event.message);
            break;
        case 'warning':
            notify.open({
                type: 'warning',
                message: event.message
            });
            break;
        case 'info':
            notify.open({
                type: 'info',
                message: event.message
            });
            break;
    }
});
